import {
  FacebookIcon,
  TwitterIcon,
  RedditIcon,
  WhatsappIcon,
  TelegramIcon,
} from '../assets/icons';

/**
 * Builds the standard set of outbound share links for a URL.
 *
 * Returns [{ href, label, className, Icon }] — the same shape NovelHeader
 * rendered inline — so any surface (novel header, dashboard Promote tab,
 * future share widgets) renders identical anchors and never drifts on the
 * URL formats.
 *
 * @param {string} url   absolute URL being shared
 * @param {string} title title used in share text
 */
export const buildShareLinks = (url, title) => {
  const encodedUrl = encodeURIComponent(url || '');
  const encodedTitle = encodeURIComponent(title || '');
  const encodedWhatsAppText = encodeURIComponent(`${title || ''} ${url || ''}`.trim());

  return [
    { href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`, label: 'Share on Facebook', className: 'facebook', Icon: FacebookIcon },
    { href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`, label: 'Share on Twitter', className: 'twitter', Icon: TwitterIcon },
    { href: `https://www.reddit.com/submit?url=${encodedUrl}&title=${encodedTitle}`, label: 'Share on Reddit', className: 'reddit', Icon: RedditIcon },
    { href: `https://wa.me/?text=${encodedWhatsAppText}`, label: 'Share on WhatsApp', className: 'whatsapp', Icon: WhatsappIcon },
    { href: `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`, label: 'Share on Telegram', className: 'telegram', Icon: TelegramIcon },
  ];
};

/**
 * Copies text to the clipboard, preferring the async Clipboard API and
 * falling back to a hidden textarea + execCommand for non-secure contexts.
 * Returns true when the copy likely succeeded.
 */
export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      return true;
    } catch {
      return false;
    }
  }
};
